import * as React from 'react'
import { BlueGreenBar } from './BlueGreenBar'

export const Divider = () => (
    <div style={{textAlign: 'center', width: '100%'}}>
        <BlueGreenBar width={140}/>
    </div>
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/Divider.tsx